module.exports = __webpack_public_path__ + "static/the-personal-mba-5d04e15cb00fd9f64bd1897e085234d1.jpg";